/**
    * Convierte el mensaje de respuesta con estructura XML recibido en la solicitud para obtener los datos para los gráficos a formato JSON con estrucutura conveniente para su procesamiento.
    * @param {Object} xmlData - Mensaje recibido en solicitud de datos para gráficos.
    * @returns {JSON} Datos para graficar.
*/
function xmlParserChartData(xmlData) {
    var dataXML = [];
    var result = {};
    var legendData = [];
    const xaxisArray = xmlData.getElementsByTagName('xaxi');
    const yaxisArray = xmlData.getElementsByTagName('yaxi');
    const seriesArray = xmlData.getElementsByTagName('serie');
    const xtitle = xmlData.getElementsByTagName('xtitle')[0].value;
    const ytitle = xmlData.getElementsByTagName('ytitle')[0].value;
    const title = xmlData.getElementsByTagName('title')[0].value;
    const minValue = xmlData.getElementsByTagName('min')[0].value;
    const maxValue = xmlData.getElementsByTagName('max')[0].value;
    const chartType = xmlData.getElementsByTagName('charttype')[0].value;
    result['xtitle'] = xtitle;
    result['ytitle'] = ytitle;
    result['title'] = title;
    result['minValue'] = minValue;
    result['maxValue'] = maxValue;
    result['chartType'] = chartType;
    if (yaxisArray.length !== 0) {
        xaxisArray.map((xaxi, index) => {
            var item = {}
            item['xaxi'] = xaxi.value;

            seriesArray.map((serie, indexSerie) => {
                var idSerie = serie.getElementsByTagName('id')[0].value;
                var serieValue = serie.children[1].value;
                var serieColor = serie.children[2].value;
                var serieStackId = chartType === "mixbar" ? serie.children[3].value : null;
                var idSerieYaxi = null;
                item[serieValue] = 0;
                idSerieYaxi = yaxisArray[index].children[indexSerie].attributes.id;
                item[serieValue] = yaxisArray[index].children[indexSerie].value;
                if (index === 0) {
                    legendData.push({
                        name: serieValue,
                        color: serieColor,
                        stackId: serieStackId
                    });
                }
            })
            dataXML.push(item);
        });
    }

    result['data'] = dataXML;
    result['legendData'] = legendData;
    return result;
}

export default xmlParserChartData;